export const getEmptyValue = (accessorKey: string) =>
  accessorKey === 'pending' || accessorKey === 'unmatched' ? 'false' : '';
